import Axios from 'axios';
import Security from '@/_helpers/security.js';

const getDefaultState = () => {
  return {
    isAppInitInnerLoaded: false
  };
};

const state = getDefaultState();

const mutations = {
  SET_APP_INIT_INNER_LOADED: (state, payload) => {
    state.isAppInitInnerLoaded = payload;
  }
};

const actions = {
  async appInitInner({ commit, dispatch }) {
    const accessToken = Security.authorizationHeader(Security.accessToken.token);

    // Пока просто идет проверка на наличие токена для запроса, но это костыль
    // Upd: 2022-02-17 Пока оставляю проверку на accessToken, но уже идет определение запускать ли метод в App.vue при условии если в $route.meta.isOuter === true
    if (accessToken !== 'Bearer undefined') {
      Axios.defaults.headers.common['Authorization'] = accessToken;

      await dispatch('integrations/fetchIntegrationsInstalls', null, { root: true });
      await dispatch('company_new/fetchTariffs', null, { root: true });
      await dispatch('company_new/get_rates', null, { root: true });

      setInterval(async () => {
        await dispatch('company_new/get_rates', null, { root: true });
      }, 60000);

      commit('SET_APP_INIT_INNER_LOADED', true);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
